(() => {
  const form = document.getElementById('WithdrawalRequestForm');

  if (!form) return;

  const detailsStep = form.querySelector('[data-withdrawal-step="details"]');
  const summaryStep = form.querySelector('[data-withdrawal-step="summary"]');
  const summaryList = form.querySelector('[data-withdrawal-summary]');
  const reviewButton = form.querySelector('[data-withdrawal-review]');
  const editButton = form.querySelector('[data-withdrawal-edit]');
  const bodyField = form.querySelector('#WithdrawalRequestForm-body');
  const orderField = form.querySelector('[data-prefill-order]');

  const fields = [
    ['Naam', '#WithdrawalRequestForm-name'],
    ['E-mailadres', '#WithdrawalRequestForm-email'],
    ['Ordernummer of referentienummer', '#WithdrawalRequestForm-order'],
    ['Postcode ter verificatie', '#WithdrawalRequestForm-postcode'],
    ['Telefoonnummer ter verificatie', '#WithdrawalRequestForm-phone'],
  ];

  const setOrderFromUrl = () => {
    if (!orderField || orderField.value) return;

    const params = new URLSearchParams(window.location.search);
    const order = params.get('order');

    if (order) {
      orderField.value = order;
    }
  };

  const getValue = (selector) => {
    const field = form.querySelector(selector);
    return field ? field.value.trim() : '';
  };

  const buildBody = () => {
    const lines = [
      'Nieuw herroepingsverzoek ontvangen.',
      '',
      'Controleer handmatig de orderstatus in Shopify en bij de fulfillment partner voordat er verdere actie wordt ondernomen. Er is geen automatische orderwijziging uitgevoerd.',
      '',
      'Ingevulde gegevens:',
    ];

    fields.forEach(([label, selector]) => {
      const value = getValue(selector);
      lines.push(`${label}: ${value || '-'}`);
    });

    lines.push('');
    lines.push('Bevestiging klant: Ik wil gebruikmaken van mijn herroepingsrecht voor deze bestelling.');
    lines.push('Tag: herroepingsverzoek');

    return lines.join('\n');
  };

  const renderSummary = () => {
    if (!summaryList) return;

    summaryList.innerHTML = '';

    fields.forEach(([label, selector]) => {
      const value = getValue(selector);
      const row = document.createElement('div');
      const term = document.createElement('dt');
      const description = document.createElement('dd');

      term.textContent = label;
      description.textContent = value || '-';

      row.append(term, description);
      summaryList.append(row);
    });
  };

  const showSummary = () => {
    if (!form.reportValidity()) return;

    renderSummary();

    if (bodyField) {
      bodyField.value = buildBody();
    }

    detailsStep.hidden = true;
    summaryStep.hidden = false;
    summaryStep.querySelector('h2')?.focus();
    summaryStep.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  const showDetails = () => {
    summaryStep.hidden = true;
    detailsStep.hidden = false;
    detailsStep.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  setOrderFromUrl();

  reviewButton?.addEventListener('click', showSummary);
  editButton?.addEventListener('click', showDetails);
  form.addEventListener('submit', () => {
    if (bodyField) {
      bodyField.value = buildBody();
    }
  });
})();
